(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2985],{

/***/ 46968:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/application-prefill",
      function () {
        return __webpack_require__(79499);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56612:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Acxiom.3b0e2e2a.png","height":50,"width":213,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEV4lq52mKh5krRss2Nqu1h5mKt4lqttrnCW4SDEAAAACHRSTlNOMGCQSEOQViVUMvYAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAaSURBVHicY2BlZGRgZ2FgZGBjYmBiZmZiAAABfAAmwBnAWgAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 96348:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Attom.7cf0d8cd.png","height":40,"width":167,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEVnY2RwYWFoZWRjaGaoLTZmZWXKPzrl9IHdAAAAB3RSTlM3R2Judp+RM1vOqAAAAAlwSFlzAAALEwAACxMBAJqcGAAAABpJREFUeJxjYGZgYmNhZmViYGJgYGRgZGQAAAF0AB+F6h7XAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 90887:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Equifax.f41cfa8b.png","height":40,"width":205,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAHlBMVEWzJUCzJUCyJECyJECxJUGxJD+yJT+yJj6zJEC3JUMg3OPaAAAACnRSTlOkSleCbTiQNYqyhh2xIwAAAAlwSFlzAAALEwAACxMBAJqcGAAAABpJREFUeJxj4GRg5mBgY2BhYGJkZmJkZWIHAAIJADZTrDwDAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 88307:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Experian.bdd3a34e.png","height":80,"width":241,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAG1BMVEUUZogdSYsmRYsqRowlRYxQVp8mRYuXNYRlKnz6ipDiAAAACXRSTlMDGAtjVVs4MnFlJc0fAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAH0lEQVR4nAXBgQEAAATDsM4w/18sYQYo4Ozu9ZJIKvEDugBG5eX2XQAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 20575:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Infutor.448d7438.png","height":262,"width":988,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAIVBMVEUgHh/HIScsHyEpHiBiHyMlHSDGHiYiHx8fHx8+HyHMHygtWzuRAAAAC3RSTlN9ZjyKQWc7SklymDvqoUQAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAaSURBVHicY2BkY2bi4GBhYuBi5GRgYGBmBQACbAA/wPDWAQAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 38680:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/dataaxle.2c9c58a1.png","height":2000,"width":2000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEVMaXEhHRwgIyYhHx8nIiIgICAiHh5r3Jh3AAAAB3RSTlMAWjghEUZvF2Sn2AAAAAlwSFlzAAALEwAACxMBAJqcGAAAAClJREFUeJxjYMAELKzMTEwsDAwMzGyMbIxMIBFGJlZGZpAIIxMTmIEOAAo7AETeLMYkAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 65966:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Demyst.5001eb93.svg","height":22,"width":16});

/***/ }),

/***/ 79499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ application_prefill; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/layouts/LayoutComponents/NextHead.jsx
var NextHead = __webpack_require__(37672);
// EXTERNAL MODULE: ./src/landingPage/datasets/meta.js
var meta = __webpack_require__(85666);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/landingPage/views/Usecases/components/TitleSection.jsx
var TitleSection = __webpack_require__(38828);
// EXTERNAL MODULE: ./src/landingPage/views/Usecases/components/DataPartners.jsx
var DataPartners = __webpack_require__(83570);
// EXTERNAL MODULE: ./src/landingPage/views/Usecases/components/Resources.jsx + 1 modules
var Resources = __webpack_require__(82558);
// EXTERNAL MODULE: ./src/landingPage/datasets/usecases/applicationprefill.js + 4 modules
var applicationprefill = __webpack_require__(18616);
// EXTERNAL MODULE: ./src/landingPage/views/Usecases/components/Recipes.jsx + 1 modules
var Recipes = __webpack_require__(41974);
;// CONCATENATED MODULE: ./src/landingPage/views/Usecases/ApplicationPreFill/ApplicationPreFill.jsx







// import { PricingGetStarted } from "../../Pricing/components/PricingGetStarted";
var ApplicationPreFill = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "application_prefill_landing",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSection/* default */.Z, {
                data: applicationprefill/* default */.Z
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Recipes/* default */.Z, {
                data: applicationprefill/* default */.Z
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DataPartners/* default */.Z, {
                dataPartners: applicationprefill/* default.dataPartners */.Z.dataPartners
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Resources/* default */.Z, (0,_object_spread/* default */.Z)({}, applicationprefill/* default */.Z))
        ]
    });
};

;// CONCATENATED MODULE: ./pages/use-cases/application-prefill.jsx




var ApplicationPreFillPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* NextHead */.B, {
                currentPath: "/use-cases/application-prefill",
                title: meta/* meta.usecases.applicationprefill.title */.$.usecases.applicationprefill.title,
                description: meta/* meta.usecases.applicationprefill.description */.$.usecases.applicationprefill.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicationPreFill, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var application_prefill = (ApplicationPreFillPage);


/***/ }),

/***/ 18616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ applicationprefill; }
});

// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/Equifax.png
var Equifax = __webpack_require__(90887);
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/dataaxle.png
var dataaxle = __webpack_require__(38680);
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/Experian.png
var Experian = __webpack_require__(88307);
;// CONCATENATED MODULE: ./src/landingPage/assets/company-logos/HazardHub.png
/* harmony default export */ var HazardHub = ({"src":"/_next/static/media/HazardHub.1cd92456.png","height":120,"width":240,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAIVBMVEX629z////39vfMwcPy7Ozzz9Do3d/czc/b3+DS1tnDjpA9ch0PAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIElEQVR4nGNghAIGFi5WBgZ2TiYGJmYGBgY2DiYGmBQABZEASy/pi8gAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/Attom.png
var Attom = __webpack_require__(96348);
;// CONCATENATED MODULE: ./src/landingPage/assets/company-logos/Quantarium.png
/* harmony default export */ var Quantarium = ({"src":"/_next/static/media/Quantarium.7339e9f4.png","height":30,"width":151,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEUjQVAiRVEmQlJNbHkiOk4lQlVLdYYnTk4lQ1HsX4Z6AAAACXRSTlNYFkhjNBtODYAIFZX2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGPgYGFnZWRkZGRgY2ZgYmBiYAAAAgwAKnom6XUAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/assets/company-logos/Precisely.png
/* harmony default export */ var Precisely = ({"src":"/_next/static/media/Precisely.c625f9b7.png","height":120,"width":214,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAFVBMVEXl0Pn+/v/////Ws/bcwPfZu/bkzvhGtLReAAAAAnRSTlPo6E7l3pYAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAfSURBVHicY2CCAEYGNmYWFlYWZgYGZmYQzczAAJMCAAZGAFWInH+iAAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/Acxiom.png
var Acxiom = __webpack_require__(56612);
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/Infutor.png
var Infutor = __webpack_require__(20575);
;// CONCATENATED MODULE: ./src/landingPage/assets/company-logos/IHSMarkit.png
/* harmony default export */ var IHSMarkit = ({"src":"/_next/static/media/IHSMarkit.b832ee2f.png","height":358,"width":1280,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEVAPkJAPkQxe1odn28WomIC73G2AAAABXRSTlMXHQ9AR6FFHmoAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAXSURBVHicY2BhZmJkZGRgYGBhZmIAsQABFQAZRqmXxwAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/landingPage/datasets/usecases/applicationprefill.js










var data = {
    usecaseInfo: {
        name: "Optimize Application Prefill",
        description: "A single platform for prefilling data pertaining to people, places, and businesses, globally.",
        button: {
            text: "Download Solution Brief",
            url: "/demyst_ap.pdf",
            download: true
        }
    },
    recipesInfo: {
        title: "Reduce application dropoff",
        description: "Access API-ready solutions for business firmographics, business credit, property characteristics, personal details, and vehicle characteristics, among many others."
    },
    recipes: [
        {
            type: "Business Data",
            title: "Business Firmographics",
            description: "Identify industry codes, annual sales revenue, number of employees, business start year, and contact details."
        },
        {
            type: "Business Data",
            title: "US Business Operating Hours",
            description: "Gather the operating hours of a business for business insurance prefill"
        },
        {
            type: "Business Data",
            title: "Business Prefill Growth Indicators",
            description: "Gather key information about a business for business insurance prefill"
        },
        {
            type: "People Data",
            title: "US Person Address From Name and Phone",
            description: "Based on name, phone, and country, prefill a person's address"
        },
        {
            type: "Business Data",
            title: "US Property Risk",
            description: "Gather small business and commercial property risk data for business or commercial property insurance pre-fill"
        },
        {
            type: "Business Data",
            title: "Property Ownership and Occupancy",
            description: "Gather property occupancy and risk data, and owner characteristics for residential property insurance pre-fill"
        },
        {
            type: "People Data",
            title: "Personal Auto Screening",
            description: "Gather basic auto risks from individuals for personal auto insurance pre-fill"
        },
        {
            type: "Other Data",
            title: "...And Many More",
            description: "Access 100's of api-ready recipes.",
            ctaText: "Access Recipe Catalog"
        }, 
    ],
    dataPartners: {
        title: "Sample Data Providers",
        description: "Access to hundreds of data partners worldwide",
        logos: [
            {
                name: "DataAxle",
                img: dataaxle/* default */.Z
            },
            {
                name: "Equifax",
                img: Equifax/* default */.Z
            },
            {
                name: "Experian",
                img: Experian/* default */.Z
            },
            {
                name: "HazardHub",
                img: HazardHub
            },
            {
                name: "Attom",
                img: Attom/* default */.Z
            },
            {
                name: "Quantarium",
                img: Quantarium
            },
            {
                name: "Precisely",
                img: Precisely
            },
            {
                name: "Acxiom",
                img: Acxiom/* default */.Z
            },
            {
                name: "Infutor",
                img: Infutor/* default */.Z
            },
            {
                name: "IHSMarkit",
                img: IHSMarkit
            }, 
        ]
    },
    resourcesInfo: {
        title: "Resources",
        description: "The latest news, technologies, and resources from our team."
    },
    resources: [
        {
            title: "Residential Property Data For Marketing Decisions",
            url: "https://demyst.com/blog/residential-property-data-improves-marketing-decisions",
            featured_image: "https://cdn.buttercms.com/d9kXSLsS46refWzF1wQ9",
            date: "2021-10-22",
            description: "Tax assessor data provides a wealth of information, including property ownership, assessed value, and property characteristics (e.g., number of floors, presence of a fireplace). However, it suffers from three major issues:",
            more: ""
        },
        {
            title: "External Data Insights for the Insurance Industry",
            url: "https://demyst.com/blog/external-data-insights-for-the-insurance-industry",
            featured_image: "https://cdn.buttercms.com/B6gv9H7MRfalVopxeDFI",
            date: "2021-10-15",
            description: "The insurance industry is undergoing a deep transformation. The global pandemic, the risks posed by climate change, and the acceleration of digitization have disrupted the industry’s standard business processes. At the same time, increasing numbers of new data products are providing more detailed insights and better predictive capabilities that improve business decisions.",
            more: ""
        },
        {
            title: "Automating Due Diligence Processes with Business Website Lookup",
            url: "https://demyst.com/blog/automating-due-diligence-processes-with-business-website-lookup",
            featured_image: "https://cdn.buttercms.com/xoTPr1u3QjmFI0qjwfGm",
            date: "2021-10-07",
            description: "Approximately 28% of businesses in the United States still lack a website, but the vast majority of them have websites providing basic information such as an official business name, business address, business phone, and contact information. Businesses that do not have a website are under significant pressure to build one given remote working requirements and the transition to e-commerce.",
            more: ""
        }, 
    ]
};
/* harmony default export */ var applicationprefill = (data);


/***/ }),

/***/ 82558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Resources; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 14 modules
var format = __webpack_require__(4758);
// EXTERNAL MODULE: ./src/landingPage/assets/demyst_meta_image.png
var demyst_meta_image = __webpack_require__(34631);
;// CONCATENATED MODULE: ./src/landingPage/views/components/HighlightCard.jsx




/* harmony default export */ var HighlightCard = (/*#__PURE__*/react.forwardRef(function(param, ref) {
    var title = param.title, url = param.url, featured_image = param.featured_image, date = param.date, description = param.description, more = param.more;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        className: "highlight-card",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: url,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "highlight-card-image",
                    style: {
                        backgroundImage: "url(".concat(featured_image || demyst_meta_image/* default */.Z, ")")
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "highlight-card-cover"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "highlight-card-textarea",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "highlight-card-title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "highlight-card-description",
                            children: description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "highlight-card-date",
                            children: (0,format/* default */.Z)(new Date(date), "LLLL dd, yyyy")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "highlight-card-more",
                            children: more
                        })
                    ]
                })
            ]
        })
    }, title);
}));

// EXTERNAL MODULE: ./src/landingPage/views/components/Slider.jsx + 1 modules
var Slider = __webpack_require__(96777);
;// CONCATENATED MODULE: ./src/landingPage/views/Usecases/components/Resources.jsx





var Resources = function(param) {
    var resources = param.resources, resourcesInfo = param.resourcesInfo;
    var card = (0,react.useRef)(null);
    var ref = (0,react.useState)(), stepSize = ref[0], setStepSize = ref[1];
    (0,react.useEffect)(function() {
        var offsetWidth = card.current.offsetWidth;
        setStepSize(offsetWidth);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "usecases_resources_section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "usecases_resources_section-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: resourcesInfo.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "usecases_resources_section-subtitle",
                    children: resourcesInfo.description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                    stepSize: stepSize,
                    children: resources.map(function(resource) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightCard, (0,_object_spread/* default */.Z)({
                            ref: card
                        }, resource), resource.url);
                    })
                })
            ]
        })
    });
};
Resources.defaultProps = {
    resources: [],
    resourcesInfo: {}
};
/* harmony default export */ var components_Resources = (Resources);


/***/ }),

/***/ 38828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_LinkButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84135);
/* harmony import */ var _components_MainCtaButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11723);



/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "usecases_title_section",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "usecases_title_section-container section-layout",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "usecases_title_section-text_container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: data.usecaseInfo.name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "usecases_title_section-description",
                            children: data.usecaseInfo.description
                        }),
                        data.usecaseInfo.button ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LinkButton__WEBPACK_IMPORTED_MODULE_1__/* .LinkButton */ .Q, {
                            download: data.usecaseInfo.button.download,
                            href: data.usecaseInfo.button.url,
                            variant: "inverted",
                            demystIcon: true,
                            children: data.usecaseInfo.button.text
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MainCtaButton__WEBPACK_IMPORTED_MODULE_2__/* .MainCtaButton */ .T, {})
                    ]
                })
            })
        })
    });
};


/***/ }),

/***/ 84135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ LinkButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65966);







var LinkButton = function(_param) {
    var _autoWidth = _param.autoWidth, autoWidth = _autoWidth === void 0 ? false : _autoWidth, _demystIcon = _param.demystIcon, demystIcon = _demystIcon === void 0 ? false : _demystIcon, hidden = _param.hidden, isExternal = _param.isExternal, onClick = _param.onClick, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = _param.size, size = _size === void 0 ? "lg" : _size, disabled = _param.disabled, to = _param.to, children = _param.children, className = _param.className, _noStyle = _param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "autoWidth",
        "demystIcon",
        "hidden",
        "isExternal",
        "onClick",
        "variant",
        "size",
        "disabled",
        "to",
        "children",
        "className",
        "noStyle"
    ]);
    var classes = noStyle !== true ? (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("button-component", variant === "inverted" && "button-component-inverted", variant === "secondary" && "button-component-secondary", variant === "secondary-alt" && "button-component-secondary-alt", hidden && "hidden", autoWidth && "button-component-autoWidth", size && "button-component-size-".concat(size), disabled && "button-component-disabled", className) : className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        href: to,
        className: classes,
        onClick: function(e) {
            onClick && onClick(e);
        },
        isExternal: isExternal
    }, props), {
        children: [
            noStyle !== true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: children
            }) : children,
            demystIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                alt: "",
                width: "16",
                height: "22",
                loading: "eager"
            })
        ]
    }));
};


/***/ }),

/***/ 11723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ MainCtaButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _LinkButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84135);
/* harmony import */ var _config_userTracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67474);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71571);







var MainCtaButton = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
    var sendCTAGaEvent = function() {
        (0,_config_userTracking__WEBPACK_IMPORTED_MODULE_2__/* .sendGaEvent */ .k8)({
            action: "CTA Click - Contact Us",
            category: "Main CTA",
            label: "/contact "
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinkButton__WEBPACK_IMPORTED_MODULE_1__/* .LinkButton */ .Q, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        demystIcon: true,
        variant: "secondary",
        onClick: sendCTAGaEvent,
        href: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.REQUEST_DEMO */ .s.REQUEST_DEMO
    }, props), {
        children: "Request a Demo"
    }));
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,1065,9774,2888,179], function() { return __webpack_exec__(46968); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);